import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar } from 'swiper/modules';
import { Event } from '../utility/event';
import { select } from '../utility/dom';
const SWIPPER_EVENT_CONTENT_CHANGE = 'swiperContentChange';
const _hasPagination = (swiper) => select('.swiper-pagination', swiper).first;
const _hasNavigation = (swiper) => {
    const prev = select('.swiper-button-prev', swiper).first;
    const next = select('.swiper-button-next', swiper).first;
    if (prev && next) {
        return { prev, next };
    }
    return false;
};
const _hasScrollbar = (swiper) => select('.swiper-scrollbar', swiper);
const _swiperConfig = (swiper) => {
    const modules = [];
    const paginationEl = _hasPagination(swiper);
    const navigationEls = _hasNavigation(swiper);
    const hasScroll = _hasScrollbar(swiper);
    paginationEl && modules.push(Pagination);
    navigationEls && modules.push(Navigation);
    hasScroll && modules.push(Scrollbar);
    const pagination = paginationEl ? {
        el: paginationEl,
        clickable: true,
    } : false;
    const navigation = navigationEls ? {
        prevEl: navigationEls.prev,
        nextEl: navigationEls.next,
    } : false;
    const scrollBar = hasScroll;
    if (swiper.classList.contains('flatlist-x')) {
        return {
            slidesPerView: swiper.dataset.slidesPerView || 'auto',
            freeMode: true,
            mousewheel: true,
            modules,
            pagination,
            navigation,
            scrollBar,
        };
    }
    return {
        modules,
        pagination,
        navigation,
        scrollBar,
    };
};
export default () => {
    let _state = {
        active: [],
    };
    const _init = () => {
        const swipers = select('.swiper').all();
        _state.active = swipers.map((swiper) => {
            swiper.addEventListener(SWIPPER_EVENT_CONTENT_CHANGE, (evt) => {
                const _instance = _state.active.find(s => s.el === evt.target);
                if (_instance) {
                    _instance.update();
                    const detail = evt.detail;
                    if (detail.resetPosition) {
                        _instance.slideTo(0, 300);
                    }
                }
            });
            return new Swiper(swiper, _swiperConfig(swiper));
        });
    };
    document.addEventListener(Event.PAGE_LOAD, _init);
    _init();
};
